import React from 'react';
import './product.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'; // Added routing imports
import { useTranslation } from 'react-i18next';

function ProductsPage({ addToCart }) {
  const { t } = useTranslation(); // ✅ Translation hook

  const products = [
    { id: 1, name: "egg_yolk_puff", price: 14, image: "/Homepage/eggyolk_pastry.jpg" },
    { id: 2, name: "taro_egg_yolk_puff", price: 14, image: "/Homepage/taropastry.jpg" },
    { id: 3, name: "pineapple_cake", price: 12.5, image: "/Homepage/pineapplecake.jpg" },
    { id: 4, name: "pepper_bun", price: 12, image: "/Homepage/pepper_cake.jpg" },
    { id: 5, name: "mung_bean_paste_pork", price: 14, image: "/Homepage/greenbean.jpg" },
    { id: 6, name: "sun_cake", price: 12, image: "/Homepage/suncake.jpg" },
  ];

  return (
    <div className="ProductsPage">
      {/* Featured Products Section */}
      <div className="featured-products">
        <h2 className="section-title">{t("featured_products")}</h2>
        <div className="product-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={t(product.name)} className="product-image" />
              <p className="product-name">{t(product.name)}</p>
              <p className="product-price">${product.price.toFixed(2)}</p>
              <Link to={`/product/${product.id}`} className="add-to-cart-btn">{t("add_to_cart")}</Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductsPage;